import React, {useEffect, useState} from 'react';
import {useNavigate, useOutletContext} from "react-router-dom";
import {useInfiniteScroll} from "../../hooks/useInfiniteScroll";
import {getMemberSettlementList} from "../../api/transaction/settlementApi";
import {EmptyState} from "../../components/common/EmptyStateProps";
import {setComma, splitDateTime} from "../../utils/format";
import LoadMoreButton from "../../components/common/LoadMoreButton";
import {OutletContextType} from "../../types/common/oulet.comtext.types";


export default function SettlementListPage() {
    const navigate = useNavigate();
    const {searchTypes, setTotalSize, searchTrigger} = useOutletContext<OutletContextType>();
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);


    const {
        accumulatedRows,
        showMoreButton,
        nextPage,
        appendPageData,
        resetPageData,
    } = useInfiniteScroll();


    const handleSearch = async () => {
        try {
            setLoading(true);
            const response = await getMemberSettlementList({
                ...searchTypes,
                page: 1
            });
            if (response?.data?.data) {
                resetPageData(response.data.data, searchTypes.size | 5);
                setTotalSize(response.data.data.totalSize || 0);
            }
        } catch (err) {
            console.error('정산 내역 에러:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleLoadMore = async () => {
        try {
            setLoadingMore(true);
            const response = await getMemberSettlementList({
                ...searchTypes,
                page: nextPage,
            });

            if (response?.data?.data) {
                appendPageData(response.data.data, searchTypes.size | 5);
            }
        } catch (err) {
            console.error('더보기 에러:', err);
        } finally {
            setLoadingMore(false);
        }
    };


    useEffect(() => {
        handleSearch();
    }, [searchTrigger]);


    if (loading) {
        return (
            <section className="bg-white no-gap">
                <div className="inner-box">
                    <p>데이터를 불러오는 중...</p>
                </div>
            </section>
        );
    }

    if (!accumulatedRows || accumulatedRows.length === 0) {
        return <EmptyState message="정산내역이 비어있습니다."/>;
    }

    return (
        <>
            <section className="bg-white no-gap">
                <div className="inner-box">
                    {accumulatedRows.map((item: any, index: number) => {

                        const isMinus = item.pendingSign === "MINUS" || item.settlementStatus === "CANCELLED";
                        const { date, time } = splitDateTime(item.useDate);
                        const content = (item.transactionName === "SERVICE_FEE" ? "서비스이용료" : "서비스위약금") + "[" + item.serviceType + "]";

                        return (
                            <>
                                <div
                                    key={item.id || index}
                                    className="payment-wrap"
                                    onClick={() => navigate(`/settlement/settlement-list/${item.settlementCode}`)}
                                    style={{cursor: "pointer"}}
                                >
                                    <div className="payment-info">
                                        <div className="info-row">
                                            <div className="time">
                                                {date}
                                                <em className="line">{time}</em>
                                            </div>
                                            <div className={
                                                item.settlementStatus === "COMPLETED"
                                                    ? "status finish"
                                                    : item.settlementStatus === "CANCELLED"
                                                        ? "status cancel"
                                                        : "status"
                                            }>{item.settlementStatusDescription}</div>
                                        </div>
                                        <div className="info-row">
                                            <div className="cont">{content}</div>
                                            <div
                                                className={isMinus ? "amount text-red" : "amount"}>{isMinus ? `-${setComma(item.settlementAmount)}` : `+${setComma(item.settlementAmount)}`}원
                                            </div>
                                        </div>
                                        <div className="info-row">
                                            <div className="method">{item.paymentMethod}</div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        );}
                    )}
                </div>
            </section>

            <LoadMoreButton
                show={showMoreButton}
                loading={loadingMore}
                onClick={handleLoadMore}
            />

        </>
    )
}